/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request'; // 获取客户自定义字段

export function getCustomerExtField(data) {
  return request.get('/v2/customer/customerExtField', {
    params: data
  });
} // 简称客户是否在客户库中存在

export function checkIsCustomerExist(data) {
  return request.get('/v2/order/isCustomerExist', {
    params: data
  });
} // 新建客户

export function addCustomer(data) {
  return request.post('/v2/customer/addCustomer', JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
} // 获取客户模板

export function getCustomerTemplate(data) {
  return request.get('/v2/customer/cusTemplate', {
    params: data
  });
} // 获取客户详情

export function getCustomerDetail(data) {
  return request.get('/v2/customer/detail', {
    params: data
  });
} // 获取客户全部历史工单

export function getCustomerOrderList(data) {
  return request.get('/order/getCustomerOrderList', {
    params: data
  });
}
export function getCustomerOrderListCount(data) {
  return request.get('/order/getCustomerOrderListCount', {
    params: data
  });
}
export function getCustomerAddressList(data) {
  return request.get('/customer/address/list', {
    params: data
  });
}